// [BD feat]  store data in cart buton of subscription :- http://prnt.sc/A7-o4SLPibym



(function() {
  'use strict';
  const select = document.querySelector('.custom-select-wrapper select');
  const addToCartBtn = document.querySelector('button[add-subscription-data]');
  if (!select || !addToCartBtn) return;

  const ATTRIBUTES = {
    VARIANT_ID: 'pass_variant-id',
    FREQUENCY: 'frequency_time',
    PLAN_ID: 'recharge_plan_id'
  };

  // ✅ hidden inputs banaye (sirf ek baar)
  ['pass_variant-id', 'frequency_time', 'recharge_plan_id'].forEach(name => {
    if (!document.querySelector(`input[name="${name}"]`)) {
      const hiddenInput = document.createElement('input');
      hiddenInput.type = 'hidden';
      hiddenInput.name = name;
      addToCartBtn.closest('form').appendChild(hiddenInput);
    }
  });

  function updateButtonAttributes(triggerSelect = false) {
    const selectedOption = select.options[select.selectedIndex];

    let selectedOfferInput = document.querySelector('.choose_an_offer_box input[type="radio"]:checked');
    if (!selectedOfferInput) {
      selectedOfferInput = document.querySelector('.choose_an_offer_box input[type="radio"]');
      if (selectedOfferInput) selectedOfferInput.checked = true;
    }

    const variantId = selectedOfferInput?.getAttribute('get_variant_id') || '';
    const rechargePlanId = selectedOfferInput?.getAttribute('recharge_plan_id') || '';
    const freq = selectedOfferInput?.closest('.choose_an_offer_box')?.querySelector('.subscription-plan-values p')?.getAttribute('this_freq_value') || '';

    // set attributes on button (for JS tracking/debugging)
    addToCartBtn.setAttribute(ATTRIBUTES.VARIANT_ID, variantId);
    addToCartBtn.setAttribute(ATTRIBUTES.FREQUENCY, freq);
    addToCartBtn.setAttribute(ATTRIBUTES.PLAN_ID, rechargePlanId);

    // ✅ update hidden inputs (for Shopify cart drawer)
    const form = addToCartBtn.closest('form');
    if (form) {
      form.querySelector('input[name="pass_variant-id"]').value = variantId;
      form.querySelector('input[name="frequency_time"]').value = freq;
      form.querySelector('input[name="recharge_plan_id"]').value = rechargePlanId;
    }
  }

  // Events
  select.addEventListener('change', () => updateButtonAttributes(false));
  document.querySelectorAll('.choose_an_offer_box input[type="radio"]').forEach(radio => {
    radio.addEventListener('change', () => updateButtonAttributes(!!addToCartBtn.getAttribute('add-subscription-data')));
  });

  // ✅ Default set after DOM ready
  window.addEventListener('load', () => {
    setTimeout(() => updateButtonAttributes(true), 300);
  });
})();

